import { Controller } from '@hotwired/stimulus'

// Handles checkbox dependencies where a child checkbox should be:
// - Disabled when parent is unchecked
// - Enabled when parent is checked
// - Automatically unchecked when parent is unchecked
export default class extends Controller {
  static targets = ['parent', 'child', 'helpText']

  connect() {
    // Only update if both parent and child targets exist
    if (this.hasParentTarget && this.hasChildTarget) {
      this.updateChildState()
    }
  }

  // Called when parent checkbox changes
  toggleChild() {
    this.updateChildState()
  }

  updateChildState() {
    // Safety check: ensure both targets exist before trying to access them
    if (!this.hasParentTarget || !this.hasChildTarget) {
      return
    }

    const isParentChecked = this.parentTarget.checked

    // Enable/disable child checkbox based on parent state
    this.childTarget.disabled = !isParentChecked

    // If parent is unchecked, uncheck the child too
    if (!isParentChecked) {
      this.childTarget.checked = false
    }

    // Toggle help text visibility
    if (this.hasHelpTextTarget) {
      if (isParentChecked) {
        this.helpTextTarget.style.display = 'none'
      } else {
        this.helpTextTarget.style.display = 'block'
      }
    }
  }
}
